import React from 'react'

const ModalCloseButton = ({onClickHandler}) => {
  return (
    <button className="modal-close-button"  onClick={onClickHandler}><i className={"custom-button-icon lnc lnc-x"}></i></button>
  )
}

export default ModalCloseButton